/**
 * Y-axis extremes that keep every reference line (e.g. indicator
 * tolerances/appetites) in view, padded so the lines don't sit flush against
 * the chart edge — mirrors the results-tab chart's `getYIntervals` (30% of the
 * combined data+reference span). When every value is equal (zero span, e.g.
 * result === tolerance === 0) a floor keeps the axis from collapsing so the
 * reference line stays visible. Returns `undefined` when there are no reference
 * values so the caller leaves the axis auto-scaled.
 */
export const getReferenceAwareYExtremes = (
  dataValues: number[],
  referenceValues: number[]
): undefined | { min: number; max: number } => {
  if (referenceValues.length === 0) {
    return undefined;
  }

  const combined = [...dataValues, ...referenceValues];
  const min = Math.min(...combined);
  const max = Math.max(...combined);
  // Floor the padding so an all-equal span (0) can't collapse the axis and hide
  // the reference line; fall back to ±1 when the shared value is also 0.
  const padding = (max - min) * 0.3 || Math.abs(max) * 0.3 || 1;

  return { min: min - padding, max: max + padding };
};
